<div class="common-header">
    <div class="common-title-zone">
        <div class="common-title">{{'COMMAND' | translate}}</div>
        <actions [actionstrip]="actions" (clickAction)="onClickAction($event)"></actions>
    </div>
</div>
<div class="common-content">
    {{command}}
    <div #scrollMessages class="command-results" (scroll)="doSomethingOnScroll($event)">
        <div class="element" [ngClass]="x.type" *ngFor="let x of cosesAnteriors">
            {{x.text}}
        </div>
    </div>
    <div class="command-bottom">
        <textarea class="command noborder" placeholder="{{'execute' | translate}}" [(ngModel)]="command"
            (keypress)="textareakeypress($event)"></textarea>
        <i class="send-button fa fa-lg fa-terminal" (click)="executeCommand()"></i>
    </div>
</div>